import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

@Injectable()
export class CloudFunctionsService {
    constructor(public functions: AngularFireFunctions) {
    }
}
